import React, { useState, useEffect } from 'react';
import { db, auth } from './firebaseConfig';
import { collection, query, getDocs, doc, updateDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';

// Imports dos componentes MUI
import {
  Box, Button, Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton, CircularProgress, Tooltip
} from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';

const ConfirmacaoToast = ({ closeToast, onConfirm, message }) => (
    <div>
      <p>{message}</p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
        <Button size="small" variant="contained" color="error" onClick={() => { onConfirm(); closeToast(); }}>Sim, Remover</Button>
        <Button size="small" variant="outlined" color="inherit" onClick={closeToast}>Não</Button>
      </div>
    </div>
);

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, "usuarios"));
        const querySnapshot = await getDocs(q);
        
        const usersList = querySnapshot.docs.map(doc => ({
            uid: doc.id,
            ...doc.data()
        }));
        setUsuarios(usersList);

      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        toast.error("Erro ao carregar lista de usuários.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [refreshTrigger]);

  const handleRemoveAdmin = (user) => {
    const removerPermissao = async () => {
      try {
        const userDocRef = doc(db, 'usuarios', user.uid);
        await updateDoc(userDocRef, {
            role: 'removido'
        });
        toast.success(`Permissão de admin removida para ${user.email || user.nome}!`);
        setRefreshTrigger(prev => !prev);
      } catch (error) {
        toast.error("Erro ao remover permissão de admin.");
        console.error("Erro ao remover admin:", error);
      }
    };

    toast.warn(
      <ConfirmacaoToast 
        message={`Tem certeza que deseja remover as permissões de administrador para ${user.email || user.nome}? O usuário não poderá mais acessar o sistema.`}
        onConfirm={removerPermissao}
      />, { position: "top-center", autoClose: false, draggable: false });
  };
  
  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <SupervisorAccountIcon color="primary" />
            <Typography variant="h5" component="h1" fontWeight="600">
              Gestão de Usuários do Sistema
            </Typography>
          </Box>
           <Tooltip title="Para adicionar um novo usuário, cadastre-o no Firebase Authentication e depois crie um documento para ele nesta coleção com o campo 'role' com valor 'admin'.">
              <InfoIcon color="action" />
           </Tooltip>
        </Box>
      </Paper>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Nome</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Email</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>UID (ID do Usuário)</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Cargo</TableCell>
              <TableCell align="center" sx={{fontWeight: 'bold'}}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
                <TableRow><TableCell colSpan={5} align="center"><CircularProgress /></TableCell></TableRow>
            ) : usuarios.length === 0 ? (
                <TableRow><TableCell colSpan={5} align="center">Nenhum usuário encontrado na coleção 'usuarios'.</TableCell></TableRow>
            ) : (
              usuarios.map(user => (
              <TableRow key={user.uid} hover>
                <TableCell>{user.nome}</TableCell>
                <TableCell>{user.email || 'Não informado'}</TableCell>
                <TableCell>{user.uid}</TableCell>
                <TableCell>{user.role}</TableCell>
                <TableCell align="center">
                  {auth.currentUser?.uid !== user.uid ? (
                    <Tooltip title="Remove a permissão de administrador. O usuário não poderá mais logar.">
                      <IconButton color="error" onClick={() => handleRemoveAdmin(user)}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Você não pode remover suas próprias permissões.">
                      <span>
                        <IconButton color="default" disabled>
                          <DeleteIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Usuarios;